import tempMeeApi from '../../../apis/tempMee';
import { filenameFromContentDisposition } from '../../../utils/downloadBlob';

// Endpoint #6 returns a CSV file (not JSON), so it is fetched as a blob. The
// filename comes from Content-Disposition, with a sensible fallback.
export const downloadPayoutReport = async (promotionId, batchId, outcome) => {
  const response = await tempMeeApi.get(
    `/payment/admin/promotion-campaigns/${promotionId}/payouts/${batchId}/report`,
    { params: { outcome }, responseType: 'blob' },
  );

  return {
    blob: response.data,
    filename: filenameFromContentDisposition(
      response.headers,
      `payout-report-${batchId}-${outcome}.csv`,
    ),
  };
};
